import IDictionaries from '@/creditflowresearch/domain/vo/dictionaries/IDictionaries';
import DictionaryMappingService, {
  IMenuProfile,
} from '@/creditflowresearch/domain/DictionaryMapping';
import buildHeaderMapping from '@/creditflowresearch/application/HeaderMenu/buildHeaderMapping';
import { HeaderMappingItem } from '@/creditflowresearch/application/actions/profile/helpers/types';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import { ISector } from '@dm-portal/sector/Sector';
import IIndustry from '@/creditflowresearch/domain/vo/IIndustry';
import { IResearchDocumentGroup } from '@/creditflowresearch/domain/vo/research/IResearchDocumentGroup';
import IRatingAgenciesMap from '@/creditflowresearch/domain/vo/dictionaries/IRatingAgenciesMap';
import {
  IDictionarySector,
  IDictionaryIndustryMapping,
  IDictionaryDealStatus,
  IDictionaryCurrency,
  IDictionaryRanking,
  IDictionaryTimeZone,
  IDictionaryCountry,
  IDictionarySizeDescription,
} from '@/creditflowresearch/domain/vo/IDictionary';
import { IRatingAgency } from '@/creditflowresearch/domain/vo/RatingAgency/IRatingAgency';
import { ProductType } from '@/creditflowresearch/domain/Product/types/ProductType';

/**
 * @deprecated Filter out products not supported by creditflowresearch.
 * Remove when LM product is fully supported or backend filters products per tenant.
 */
export const filterSupportedProducts = (products: IProduct[]): IProduct[] =>
  products.filter((product) => product.abbreviation !== ProductType.LM);

export const initDictionaries: IDictionariesState = {
  isHeaderInitialized: false,
  mapping: {},
  defaultActiveMapping: {},
  defaultActiveRegion: {},
  defaultActiveProduct: {},
  sectorsMenu: [],
  industriesMenu: [],
  productsList: [],
  regionsList: [],
  sectorsList: {},
  industriesList: {},
  sectorsListAll: [],
  industriesListAll: [],
  researchDocumentGroupList: [],
  ratingAgenciesMap: {},
  dealStatuses: [],
  currencies: [],
  rankings: [],
  timeZones: [],
  ratingAgencies: [],
  countries: [],
};

export interface IDictionariesState {
  isHeaderInitialized: boolean,
  mapping: Record<string, HeaderMappingItem> | {},
  defaultActiveMapping: any,
  defaultActiveRegion: IRegion | {},
  defaultActiveProduct: IProduct | {},
  sectorsMenu: IMenuProfile[][][],
  industriesMenu: IMenuProfile[][][],
  productsList: IProduct[] | [],
  regionsList: IRegion[],
  sectorsList: Record<string, IDictionarySector> | {},
  industriesList: Record<string, IDictionaryIndustryMapping> | {},
  sectorsListAll: ISector[] | [],
  industriesListAll: IIndustry[] | [],
  researchDocumentGroupList: IResearchDocumentGroup[] | [],
  ratingAgenciesMap: IRatingAgenciesMap | {},
  hasServerError?: boolean,
  dealStatuses?: IDictionaryDealStatus[] | [],
  currencies?: IDictionaryCurrency[] | [],
  rankings?: IDictionaryRanking[] | [],
  timeZones?: IDictionaryTimeZone[] | [],
  ratingAgencies?: IRatingAgency[] | [],
  countries?: IDictionaryCountry[] | [],
  sizeDescriptions?: IDictionarySizeDescription[] | [],
}

export const prepareDictionariesData = (
  {
    headerMapping,
    productsList,
    regionsList,
    sectorsList,
    industriesList,
    toolsList,
    ratingAgenciesMap,
    researchDocumentGroupList,
    hasServerError,
  } :IDictionaries,
): IDictionariesState => {
  if (hasServerError) {
    return {
      isHeaderInitialized: false,
      defaultActiveMapping: {},
      defaultActiveRegion: {},
      defaultActiveProduct: {},
      mapping: {},
      sectorsMenu: [],
      industriesMenu: [],
      productsList: [],
      regionsList: [],
      sectorsList: {},
      industriesList: {},
      sectorsListAll: [],
      industriesListAll: [],
      researchDocumentGroupList: [],
      ratingAgenciesMap: {},
      ratingAgencies: [],
    };
  }
  const mappings = buildHeaderMapping(
    productsList,
    regionsList,
    { toolsList: toolsList ?? [], headerMapping: headerMapping ?? {} },
  );

  return {
    defaultActiveMapping: mappings.activeMapping ?? {},
    defaultActiveRegion: mappings.defaultRegion ?? {},
    defaultActiveProduct: mappings.defaultProduct ?? {},
    isHeaderInitialized: true,
    mapping: mappings.mappedData,
    sectorsMenu: DictionaryMappingService.prepareSectorsMenu(sectorsList),
    industriesMenu: DictionaryMappingService.prepareIndustriesMenu(industriesList),
    productsList: filterSupportedProducts(productsList),
    regionsList,
    sectorsList: DictionaryMappingService.getMappedSectors(sectorsList),
    industriesList: DictionaryMappingService.getMappedIndustries(industriesList),
    sectorsListAll: sectorsList,
    industriesListAll: industriesList,
    researchDocumentGroupList,
    ratingAgenciesMap,
  };
};
